export default "__VITE_ASSET__8f9d7524__"